const data = [
  {
    id: Math.random() * 10,
    name: "Bill_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Date",
        label: "Bill Date",
        type: "Date",
        min: 0,
        max: Infinity,
        restrictDateRange: true,
        isRequired: true,
        Reference_field: "financialYear",
      },
      {
        id: Math.random() * 10,
        name: "CashOrDebit",
        label: "C/D",
        type: "inputdrop",
        dropdowndata: ["Debit", "Cash"],
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Invoice_No",
        label: "Bill No",
        type: "text",
        icon: "IoSettingsOutline",
        disabled: true,
      },
      // {
      //   id: Math.random() * 10,
      //   name: "Bill_Type",
      //   label: "Bill For",
      //   type: "inputdrop",
      //   dropdowndata: ["Booking"],
      //   min: 0,
      //   max: Infinity,
      // },
      {
        id: Math.random() * 10,
        name: "Inv_Type",
        label: "Inv. Type",
        type: "inputdrop",
        dropdowndata: ["Tax Invoice", "Bill Of Supply", "Retail Invoice", "Other", "Performence Invoice"],
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Load_Type",
        label: "Bill For",
        type: "inputdrop",
        dropdowndata: ["PTL", "FTL", "Booking (Broker)", "Delivered (PTL)"],
        min: 0,
        isRequired: true,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "HSN_Code",
        label: "HSN ",
        masterName: "HSN_Code",
        type: "InputDropForQuery",
      },
      {
        id: Math.random() * 10,
        name: "Party",
        label: "Account",
        type: "InputDropForQuery",
        masterName: "Customer_Account_From_Account_Balance",
        isRequired: true,
        variable: {
          accountType: ["Customer Account"],
        },
      },
      {
        id: Math.random() * 10,
        name: "RCM",
        label: "RCM",
        type: "inputdrop",
        dropdowndata: ["YES", "NO"],
        disableDependOn: {
          section: "Bill_Details",
          name: "Party",
          disableOn: "GST_Number",
          value: "NO",
        },
        min: 0,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Tax_Type",
        label: "Tax Type",
        type: "text",

        min: 0,
        max: Infinity,
        disabled: true,
      },
      // {
      //   id: Math.random() * 10,
      //   name: "Tax_Type",
      //   label: "Tax Type",
      //   type: "text",

      //   min: 0,
      //   max: Infinity,
      // },
      // {
      //   id: Math.random() * 10,
      //   name: "Sales_Account",
      //   label: "Sales Ac.",
      //   type: "text",

      //   min: 0,
      //   max: Infinity,
      // },

      // {
      //   id: Math.random() * 10,
      //   name: "Party",
      //   label: "Party",
      //   type: "InputDropForQuery",
      //   //Account
      //   masterName: "Vendor_Account",
      //   // dropdowndata: AccountDetails,
      //   min: 0,
      //   max: Infinity,
      // },
    ],
  },
];
const DocUpload = {
  Imagefileds: [
    {
      id: Math.random() * 10,
      name: "File",
      label: "",
    },
  ],
};

const LMSVoucherNumnerConfig = [
  {
    id: Math.random() * 10,
    name: "Book_Code_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Voucher_Series",
        label: "Book Code ",
        masterName: "Voucher_Series",
        // dropdowndata: GetBookCodes,
        variable: {
          Voucher_Type: "LMS Sales Bill",
        },
        type: "InputDropForQuery",
      },
      {
        id: Math.random() * 10,
        name: "Bill_No",
        label: "Next Number",
        type: "number",

        min: 5,
        max: 5,
      },
    ],
  },
];

const LMSSalesBillConfiguration = [
  {
    id: Math.random() * 10,
    name: "Config_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Default_CashOrDebit",
        label: "Default C/D",
        type: "inputdrop",
        dropdowndata: ["Debit", "Cash"],
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Default_Voucher_Series",
        label: "Default Voucher Series",
        type: "InputDropForQuery",
        masterName: "Voucher_Series",
        variable: {
          Voucher_Type: "LMS Sales Bill",
        },
        min: 0,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Default_LoadType",
        label: "Default Bill For",
        type: "inputdrop",
        dropdowndata: ["PTL", "FTL", "Booking (Broker)", "Delivered (PTL)"],
        min: 0,

        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Default_HSNCode",
        label: "Default HSN ",
        masterName: "HSN_Code",
        type: "InputDropForQuery",
      },
      {
        id: Math.random() * 10,
        name: "Default_Party",
        label: "Default Account",
        type: "InputDropForQuery",
        masterName: "Customer_Account_From_Account_Balance",

        variable: {
          accountType: ["Customer Account"],
        },
      },
      {
        id: Math.random() * 10,
        name: "Default_TaxGroup",
        label: "Default Tax",
        type: "InputDropForQuery",
        masterName: "SalesInvoiceType",
        variable: {
          Invoice_Type: "Sales",
        },
      },
      {
        id: Math.random() * 10,
        name: "Default_SalesAccount",
        label: "Default Sales Account",
        type: "InputDropForQuery",
        masterName: "General_Account",
        variable: {
          accountType: ["General Account"],
          AccountGroup: "66ceddd8c384037d477d47e1",
        },
      },
      {
        id: Math.random() * 10,
        name: "Default_RCM",
        label: "Default RCM",
        type: "inputdrop",
        dropdowndata: ["YES", "NO"],
      },
      {
        id: Math.random() * 10,
        name: "Default_LOCK_CN",
        label: "Default Lock CN",
        type: "inputdrop",
        dropdowndata: ["YES", "NO"],
      },
    ],
  },
];

const initialState = [
  {
    _id: Math.random() * 10,
    Name: "CGST ON LR",
    Expense_Account: { Account_Name: "CGST(O/P)" },
    At_Percentage: 0,
    Rate: 0,
    Amount: 0,
  },
  {
    _id: Math.random() * 10,
    Name: "SGST ON LR",
    Expense_Account: { Account_Name: "SGST(O/P)" },
    At_Percentage: 0,
    Rate: 0,
    Amount: 0,
  },
  // {
  //   _id: Math.random() * 10,
  //   Name: "IGST ON LR",
  //   Expense_Account: { Account_Name: "IGST(O/P)" },
  //   At_Percentage: 0,
  //   Rate: 0,
  //   Amount: 0,
  // },
  {
    _id: Math.random() * 10,
    Name: "Round Off",
    At_Percentage: 0,
    Expense_Account: { Account_Name: "DISCOUNT A/C" },
    Rate: 0,
    Amount: 0,
  },
];

const fields1 = [
  {
    id: Math.random() * 10,
    name: "Stock_Item",
    Input: true,
    type: "InputDropForQuery",
    masterName: "StockItem",
    value: "",
  },
  {
    id: Math.random() * 10,
    name: "Account",
    Input: true,
    type: "InputDropForQuery",
    variable: {
      accountGroup: "Sales",
    },
    masterName: "General_Account",
    value: "",
  },

  {
    id: Math.random() * 10,
    name: "HSN_Code",
    Input: true,
    type: "InputDropForQuery",
    masterName: "HSN_Code",
    value: "",
  },
  {
    id: Math.random() * 10,
    name: "Tax_Rate",
    Input: true,
    type: "number",
    value: "",
    disabled: true,
  },
  {
    id: Math.random() * 10,
    name: "Particular",
    Input: true,
    type: "text",
    value: "",
  },
  {
    id: Math.random() * 10,
    name: "Quantity",
    label: "Quantity",
    Input: true,
    type: "number",
    value: "",
  },
  {
    id: Math.random() * 10,
    name: "Item_Value",
    label: "Rate",
    Input: true,
    type: "number",
    value: "",
  },
  {
    id: Math.random() * 10,
    name: "Amount",
    label: "Amount",
    Input: true,
    type: "number",
    value: "",
    disabled: true,
  },
];

export { DocUpload, fields1, data, initialState, LMSSalesBillConfiguration, LMSVoucherNumnerConfig };
// const data = [
//   {
//     id: Math.random() * 10,
//     name: "Bill_Details",
//     fields: [
//       {
//         id: Math.random() * 10,
//         name: "Doc_Date",
//         label: "Bill Date",
//         type: "Date",

//         min: 0,
//         max: Infinity,
//       },
//       {
//         id: Math.random() * 10,
//         name: "CashOrDebit",
//         label: "C/D",
//         type: "inputdrop",
//         dropdowndata: ["Debit", "Cash"],
//         min: 0,
//         max: Infinity,
//       },
//       {
//         id: Math.random() * 10,
//         name: "Book_Code",
//         label: "Book Code",
//         type: "text",
//       },
//       {
//         id: Math.random() * 10,
//         name: "Bill_No",
//         label: "Bill No",
//         type: "number",
//         min: 5,
//         max: 5,
//       },
//       {
//         id: Math.random() * 10,
//         name: "Bill_Type",
//         label: "Bill For",
//         type: "inputdrop",
//         dropdowndata: ["Lr", "Load", "Booking"],
//         min: 0,
//         max: Infinity,
//       },
//       {
//         id: Math.random() * 10,
//         name: "Inv_Type",
//         label: "Inv. Type",
//         type: "inputdrop",
//         dropdowncontent: [
//           "Tax Invoice",
//           "Bill Of Supply",
//           "Retail Invoice",
//           "Other",
//           "Performence Invoice",
//         ],
//         min: 0,
//         max: Infinity,
//       },
//       {
//         id: Math.random() * 10,
//         name: "HSN_Code",
//         label: "HSN",
//         type: "inputdrop",
//         dropdowncontent: [
//           "Tax Invoice",
//           "Bill Of Supply",
//           "Retail Invoice",
//           "Other",
//           "Performence Invoice",
//         ],
//         min: 0,
//         max: Infinity,
//       },
//       {
//         id: Math.random() * 10,
//         name: "Account",
//         label: "Account",
//         type: "inputdrop",
//         dropdowncontent: [
//           "Tax Invoice",
//           "Bill Of Supply",
//           "Retail Invoice",
//           "Other",
//           "Performence Invoice",
//         ],
//         min: 0,
//         max: Infinity,
//       },
//       // {
//       //   id: Math.random() * 10,
//       //   name: "Tax_Type",
//       //   label: "Tax Type",
//       //   type: "text",

//       //   min: 0,
//       //   max: Infinity,
//       // },
//       // {
//       //   id: Math.random() * 10,
//       //   name: "Sales_Account",
//       //   label: "Sales Ac.",
//       //   type: "text",

//       //   min: 0,
//       //   max: Infinity,
//       // },

//       {
//         id: Math.random() * 10,
//         name: "Party",
//         label: "Party",
//         type: "inputdrop",
//         dropdowncontent: [
//           "Tax Invoice",
//           "Bill Of Supply",
//           "Retail Invoice",
//           "Other",
//           "Performence Invoice",
//         ],
//         min: 0,
//         max: Infinity,
//       },
//       {
//         id: Math.random() * 10,
//         name: "Get_Only_Bill_Party",
//         label: "Get Only Bill Party?",
//         type: "checkbox",
//         min: 0,
//         max: Infinity,
//       },
//     ],
//   },
// ];
// const DocUpload = {
//   Imagefileds: [
//     {
//       id: Math.random() * 10,
//       name: "File",
//       label: "",
//     },
//   ],
// };

// const initialState = [
//   {
//     _id: Math.random() * 10,
//     Name: "CGST ON LR",
//     Expense_Account: { Account_Name: "CGST(O/P)" },
//     At_Percentage: 0,
//     Rate: 0,
//     Amount: 0,
//   },
//   {
//     _id: Math.random() * 10,
//     Name: "SGST ON LR",
//     Expense_Account: { Account_Name: "SGST(O/P)" },
//     At_Percentage: 0,
//     Rate: 0,
//     Amount: 0,
//   },
//   // {
//   //   _id: Math.random() * 10,
//   //   Name: "IGST ON LR",
//   //   Expense_Account: { Account_Name: "IGST(O/P)" },
//   //   At_Percentage: 0,
//   //   Rate: 0,
//   //   Amount: 0,
//   // },
//   {
//     _id: Math.random() * 10,
//     Name: "Round Off",
//     At_Percentage: 0,
//     Expense_Account: { Account_Name: "DISCOUNT A/C" },
//     Rate: 0,
//     Amount: 0,
//   },
// ];
// export { data, DocUpload, initialState };
